import React from 'react';
import homeIllustration from '../../../../assets/images/permission.svg';

export const NoAccessView = (): JSX.Element => (
  <div className="NoAccess-element">
    <h1>Sorry, you don&apos;t have permission to this tool.</h1>
    <img src={homeIllustration} alt="" />
  </div>
);
